import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';

import {
  configApiRef,
  googleAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

// OPS-50 — Sign-in page configuration.
//
// The new Backstage frontend system (@backstage/frontend-defaults)
// drives the sign-in page through an extension. Without overriding
// it, the default extension renders a guest sign-in card regardless
// of what's in app-config.production.yaml's auth.providers block —
// because that config controls BACKEND providers, not the FRONTEND
// sign-in UI.
//
// In development we keep guest enabled so local iteration doesn't
// require real GCP OAuth credentials. In production we render a
// Google sign-in card, backed by googleAuthApiRef, which kicks off
// the OAuth flow against the @backstage/plugin-auth-backend-module-
// google-provider registered in packages/backend/src/index.ts.
//
// Pattern adapted from:
// https://backstage.io/docs/auth/#conditionally-render-sign-in-provider
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const isDev = configApi.getString('auth.environment') === 'development';

      if (isDev) {
        return <SignInPage {...props} providers={['guest']} />;
      }

      return (
        <SignInPage
          {...props}
          provider={{
            id: 'google-auth-provider',
            title: 'Google',
            message: 'Sign in with your Edgebeam Google account',
            apiRef: googleAuthApiRef,
          }}
        />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
